
















import { Vue, Component } from 'vue-property-decorator';
import { routeNames } from '@/utils/router';
import { ComponentOptions } from 'vue/types/options';
import { RootState } from '@/store';
import { State } from 'vuex-class';

@Component({
  name: 'app-page-header',
  components: {
    CopyRegisterIdButton: () => import('@/components/CopyRegisterIdButton.vue'),
  },
  routeNames: routeNames
} as ComponentOptions<Vue>)
export default class extends Vue {

  @State((state: RootState) => state.dataManagement.navigatedListIndexes)
  private navigatedListIndexes!: string[];

}
